import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter, generatePath } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import {
  downloadCalendarGroupReports,
  getAllCalendars,
  getBookingStatusReports,
  getCalendarGroupReports,
} from "store/actions"
import TableComponent from "components/Table"
import Flatpickr from "react-flatpickr"
import bookingReportListColumns from "./bookingReportListColumns"
import BookingReportsChart from "./bookingReportsChart"
import Select from "react-select"
import { URL_PATHS } from "constants/index"

const BookingsReport = ({
  history,
  getCalendarGroupReports,
  calendarGroupReports,
  bookingStatusReports,
  getBookingStatusReports,
  allCalendars,
  getAllCalendars,
  downloadCalendarGroupReports,
  match,
}) => {
  const { event_id } = match?.params
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [showResetButton, setShowResetButton] = useState(false)
  const [calendarGroupValue, setCalendarGroupValue] = useState(null)
  const [defaultParams, setDefaultParams] = useState({
    page: 1,
    o: "bookings_count",
    od: "desc",
  })

  useEffect(() => {
    getCalendarGroupReports({ ...defaultParams })
    getBookingStatusReports({})
    getAllCalendars({ type: 2 })
  }, [])

  const searchHandler = () => {
    getCalendarGroupReports({
      page: 1,
      o: defaultParams?.o,
      od: defaultParams?.od,
      start: startDate,
      end: endDate,
      ...(calendarGroupValue?.value
        ? { calendar_id: calendarGroupValue.value }
        : {}),
    })
    getBookingStatusReports({
      start: startDate,
      end: endDate,
      ...(calendarGroupValue?.value
        ? { calendar_id: calendarGroupValue.value }
        : {}),
    })
    setShowResetButton(true)
    setDefaultParams({ ...defaultParams, page: 1 })
  }

  const resetSearchHandler = () => {
    getCalendarGroupReports({
      page: 1,
      o: defaultParams?.o,
      od: defaultParams?.od,
      ...(calendarGroupValue?.value
        ? { calendar_id: calendarGroupValue.value }
        : {}),
    })
    getBookingStatusReports({
      ...(calendarGroupValue?.value
        ? { calendar_id: calendarGroupValue.value }
        : {}),
    })
    setShowResetButton(false)
    setStartDate("")
    setEndDate("")
    setDefaultParams({ ...defaultParams, page: 1 })
  }

  const handlePageChange = page => {
    getCalendarGroupReports({
      page: page,
      o: defaultParams?.o,
      od: defaultParams?.od,
      start: startDate,
      end: endDate,
      ...(calendarGroupValue?.value
        ? { calendar_id: calendarGroupValue.value }
        : {}),
    })
    setDefaultParams({ ...defaultParams, page: page })
  }

  const handleSort = (type, { sortField, sortOrder }) => {
    getCalendarGroupReports({
      o: sortField,
      od: sortOrder,
      page: 1,
      start: startDate,
      end: endDate,
      ...(calendarGroupValue?.value
        ? { calendar_id: calendarGroupValue.value }
        : {}),
    })
    setDefaultParams({ o: sortField, od: sortOrder, page: 1 })
  }

  const actions = [
    {
      name: "Sub Calendars",
      onClick: item => {
        history.push({
          pathname: generatePath(URL_PATHS.SUB_CALENDAR_REPORTS, {
            event_id: event_id,
            calendar_id: item?.id,
          }),
        })
      },
      icon: "bx bx-calendar",
      isAvailable: true,
    },
    {
      name: "Users",
      onClick: item => {
        history.push({
          pathname: generatePath(URL_PATHS.USER_BOOKING_REPORTS, {
            event_id: event_id,
          }),
          search: `?calendar_id=${item?.id}`,
        })
      },
      icon: "bx bxs-user",
      isAvailable: true,
    },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageMetaTags title="Bookings" />
          <BreadcrumbTitle
            title={"Bookings"}
            breadcrumbItems={[
              { title: "Dashboard" },
              {
                title: "Experience Reports",
                link: generatePath(URL_PATHS.EVENT_REPORTS, {
                  id: event_id,
                }),
              },
              { title: "Bookings" },
            ]}
          />
          <Row className="d-flex justify-content-end mb-3">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="light"
                content="Back"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xl={3}>
              <Select
                value={calendarGroupValue}
                placeholder="Select Calendar Group"
                options={allCalendars?.map(item => ({
                  label: item?.name,
                  value: item?.id,
                }))}
                onChange={v => {
                  setCalendarGroupValue(v)
                  getCalendarGroupReports({
                    page: 1,
                    o: defaultParams?.o,
                    od: defaultParams?.od,
                    ...(v?.value ? { calendar_id: v.value } : {}),
                    start: startDate,
                    end: endDate,
                  })
                  getBookingStatusReports({
                    ...(v?.value ? { calendar_id: v.value } : {}),
                    start: startDate,
                    end: endDate,
                  })
                  setDefaultParams({ ...defaultParams, page: 1 })
                }}
                isClearable={true}
              />
            </Col>
          </Row>
          <BookingReportsChart calendarGroupId={calendarGroupValue?.value} />
          {!!calendarGroupReports && (
            <Card>
              <CardBody>
                <Row className="justify-content-center">
                  <Col xs="auto" className="my-1">
                    <Flatpickr
                      className="form-control bg-white"
                      placeholder="Start Date"
                      options={{
                        altInput: true,
                        altFormat: "Y-m-d",
                        dateFormat: "Y-m-d",
                      }}
                      value={startDate}
                      onChange={(selectedDates, dateStr) => {
                        setStartDate(dateStr)
                      }}
                    />
                  </Col>
                  <Col xs="auto" className="my-1">
                    <Flatpickr
                      className="form-control bg-white"
                      placeholder="End Date"
                      options={{
                        altInput: true,
                        altFormat: "Y-m-d",
                        dateFormat: "Y-m-d",
                      }}
                      value={endDate}
                      onChange={(selectedDates, dateStr) => {
                        setEndDate(dateStr)
                      }}
                    />
                  </Col>
                  <Col xs="auto" className="my-1">
                    <SaveButton
                      type="button"
                      content="Search"
                      onClick={searchHandler}
                    />
                  </Col>
                  {showResetButton && (
                    <Col xs="auto" className="my-1">
                      <SaveButton
                        type="button"
                        content="Reset"
                        color="light"
                        onClick={resetSearchHandler}
                      />
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col>
                    <span>
                      <label># of Bookings Confirmed: </label>
                      {!!bookingStatusReports?.confirmed_bookings
                        ? " " + bookingStatusReports?.confirmed_bookings
                        : " 0"}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span>
                      <label># of Bookings Cancelled: </label>
                      {!!bookingStatusReports?.cancelled_bookings
                        ? " " + bookingStatusReports?.cancelled_bookings
                        : " 0"}
                    </span>
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col className="algin-self-center">
                    <h5># of Bookings per Calendar Groups</h5>
                  </Col>
                  <Col xs="auto">
                    <SaveButton
                      type="button"
                      content="Download Report"
                      onClick={() => {
                        downloadCalendarGroupReports({
                          download: 1,
                          ...defaultParams,
                          start: startDate,
                          end: endDate,
                          ...(calendarGroupValue?.value
                            ? { calendar_id: calendarGroupValue.value }
                            : {}),
                        })
                      }}
                    />
                  </Col>
                </Row>
                <TableComponent
                  data={calendarGroupReports?.data}
                  columns={bookingReportListColumns({
                    type: "calendar-group",
                    eventId: event_id,
                  })}
                  paginationData={{
                    current_page: calendarGroupReports?.current_page,
                    last_page: calendarGroupReports?.last_page,
                    total_items: calendarGroupReports?.total,
                    items_per_page: calendarGroupReports?.per_page,
                    from: calendarGroupReports?.from,
                    to: calendarGroupReports?.to,
                    first_page: 1,
                  }}
                  onPageChange={handlePageChange}
                  onTableSort={handleSort}
                  actions={actions}
                  actionsColumnName="View More"
                />
              </CardBody>
            </Card>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  calendarGroupReports: state.BookingsFeature.calendarGroupReports,
  bookingStatusReports: state.BookingsFeature.bookingStatusReports,
  allCalendars: state.BookingsFeature.allCalendars,
})

const mapDispatchToProps = dispatch => ({
  getCalendarGroupReports: values => dispatch(getCalendarGroupReports(values)),
  getBookingStatusReports: values => dispatch(getBookingStatusReports(values)),
  getAllCalendars: values => dispatch(getAllCalendars(values)),
  downloadCalendarGroupReports: values =>
    dispatch(downloadCalendarGroupReports(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BookingsReport))
